import { allRoles } from '@/roles'
import CustomFields from '@/models/CustomFields'
import Organization from '@/models/Organization'

const currentOrganization = new Organization()

const state = {
  allRoles,
  currentOrganization: null,
  customFields: []
}

const getters = {
  currentOrganization () {
    return currentOrganization
  },
  allDocumentationTypes (state, getters, rootState, rootGetters) {
    const org = rootGetters['organizations/currentOrganization']
    return org && org.documentation ? org.documentation : []
  },
  getOrganizationDoc: (state, getters, rootState, rootGetters) => (docId) => {
    const org = rootGetters['organizations/currentOrganization']
    return org && org.documentation ? org.documentation[docId] : null
  },
  settings (state, getters, rootState, rootGetters) {
    return currentOrganization.settings
  },
  customProperties: (state) => (attachedTo) => {
    if (!attachedTo) {
      return state.customFields
    } else {
      return state.customFields.filter(x => x.attachedTo.includes(attachedTo))
    }
  }
}

const mutations = { }

const actions = {
  async bindCurrentOrganization ({ commit, rootState }) {
    currentOrganization.on('save.success, fetch.success', () => {
      commit('atlas/syncModel', {
        path: 'organizations.currentOrganization',
        value: { ...currentOrganization.$ }
      }, { root: true })
    })
    await currentOrganization.fetch(rootState.user.currentUser.currentOrganization)
  },
  async loadCustomFields ({ commit }) {
    const cf = new CustomFields()
    await cf.fetch({ organization: currentOrganization.id })

    commit('atlas/syncModel', {
      path: 'organizations.customFields',
      value: cf.models.map(x => { return { ...x.$ } })
    }, { root: true })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
